import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { ModalFooter as SyfModalFooter } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { spacing } from 'syf-component-library/defaultTheme';
export const ModalWrapper = styled.div `
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
  overflow-y: auto;

  @media ${query.greaterThanLarge} {
    max-width: 1114px;
  }
`;
export const ModalBody = styled.div `
  flex: 1;
`;
export const ModalFooter = styled(SyfModalFooter) `
  width: 100%;
  padding: ${spacing.large}px;
  gap: ${spacing.small}px;
  flex: 0 0 auto;
  /** overwrite syf min-height */
  min-height: unset;

  @media ${query.lessThanMedium} {
    padding: ${spacing.base}px;
  }

  & > button {
    margin-bottom: inherit;

    @media ${query.greaterThanMedium} {
      min-width: fit-content;
    }
  }
`;
